module.exports = __webpack_public_path__ + "img/img-112.c51f735c.png";